export default __webpack_public_path__ + "static/media/BuckeyeLeaf-Scarlet.fe7972e3.svg";